import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Tooltip,
  Divider,
  CardMedia,
  IconButton,
  Modal,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
  OpenInFull as OpenInFullIcon,
  // Download as DownloadIcon,
  Image as ImageIcon,
} from "@mui/icons-material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { ArrowForwardIos } from "@mui/icons-material";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import CustomerServices from "services/Customer";
import VehicleBookingServices from "services/VehicleBooking";
import { FiDownload } from "react-icons/fi";
import pdfIcon from "assets/Icons/pdfIcon.png";
import moment from "moment";
import { CommaSeparator } from "utils";
import JSZip from "jszip";
import HoverZoomSplit from "components/hoverZoom";

// import { saveAs } from "file-saver";

function VehicleBookingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();

  const [vehicleDetails, setVehicleDetails] = useState();
  const [customerDetails, setCustomerDetails] = useState();
  const [activeTab, setActiveTab] = useState("vehicle-specs");
  const [openFullImage, setOpenFullImage] = useState(false);

  const images =
    vehicleDetails?.pictures?.map((picture, index) => {
      if (picture.startsWith("https://static.w8shipping.com/image")) {
        return picture;
      } else {
        return process.env.REACT_APP_IMAGE_BASE_URL + picture;
      }
    }) || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const total = images.length;

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === total - 1 ? 0 : prev + 1));
  };

  const handleThumbnailClick = (idx) => {
    setCurrentIndex(idx);
  };

  const handleExpand = () => {
    setOpenFullImage(true);
  };

  const handleCloseModal = () => {
    setOpenFullImage(false);
  };

  const currentImage = images[currentIndex];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      setActiveTab(sectionId);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const getCustomerBooking = async (id) => {
    try {
      const { data } = await CustomerServices.getCustomerBooking();
      setCustomerDetails(data?.customers.find((e) => e.id === id));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getVehicleBookingDetail = async () => {
    try {
      let params = { booking_id: id };
      params.shipping_details = "true";
      const { data } = await VehicleBookingServices.getVehicleBookingDetail(
        params
      );
      const { details } = data;
      setVehicleDetails(details);
      getCustomerBooking(details?.customer_id);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    if (id) {
      getVehicleBookingDetail();
    }
  }, [id]);


   useEffect(() => {
    const handleKeydown = (e) => {
      if (e.key === "ArrowLeft") {
        handlePrev();  
      }
      if (e.key === "ArrowRight") {
        handleNext();
      }
    };

    window.addEventListener("keydown", handleKeydown);

    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [total]);
  const attachments = vehicleDetails?.invoices_details || [];
  const isContainerBooked = Boolean(vehicleDetails?.vehicle);

  const handleAttachmentDownload = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const downloadAllImages = () => {
    const zip = new JSZip();

    const downloadPromises = vehicleDetails?.pictures?.map((imagePath) =>
      fetch(`${process.env.REACT_APP_IMAGE_BASE_URL}${imagePath}`)
        .then((response) => response.blob())
        .then((data) => {
          const filename = imagePath.split("/").pop();
          zip.file(filename, data);
        })
    );

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: "blob" }).then((blob) => {
        const zipFilename = "images.zip";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = zipFilename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  const handleBackClick = () => {
    navigate("/vehicle-booking-list");
  };

  return (
    <Box sx={{ m: 4 }}>
      <Modal
        open={openFullImage}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0,0,0,0.7)",
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.7)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
            }}
            onClick={handleCloseModal}
          >
            <CloseIcon />
          </IconButton>

          {/* Left Arrow Icon */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              top: "50%",
              left: 12,
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.6)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
            }}
            disabled={currentIndex === 0}
          >
            <ArrowBackIcon />
          </IconButton>

          {/* Right Arrow Icon */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              top: "50%",
              right: 12,
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.6)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
            }}
            disabled={currentIndex === total - 1}
          >
            <ArrowForwardIcon />
          </IconButton>

          <CardMedia
            component="img"
            image={currentImage}
            alt="Full Size Image"
            sx={{ width: "100vw", height: "100vh", objectFit: "contain" }}
          />
        </Box>
      </Modal>

      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <IconButton onClick={handleBackClick} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography
          sx={{
            color: "#2C6B2F",
            ml: 1,
            fontSize: "20px",
          }}
        >
          Detail View
        </Typography>

        <ArrowForwardIcon sx={{ ml: 1, mr: 1 }} />

        <Typography
          sx={{
            fontWeight: "bold",
            color: "#333",
            mb: 2,
            fontSize: "32px",
            mt: 2,
            fontWeight: 700,
            fontStyle: "bold",
          }}
        >
          {/* {vehicleDetails?.veh_model?.name} */}
          {vehicleDetails?.veh_make?.name ?? "-"} {"-"}{" "}
          {vehicleDetails?.color ?? "-"}
        </Typography>
      </Box>

      {/* <Typography sx={{ fontWeight: "bold", color: "#333", mb: 2, fontSize: "32px", mt: 2, fontWeight: 700, fontStyle: "bold"}}>
                {vehicleDetails?.veh_make?.name ?? '-'} {"-"} {vehicleDetails?.color ?? '-'}
            </Typography> */}

      <Box m={2} mt={2}>
        <Grid
          container
          spacing={2}
          sx={{
            BackgroundColor: "#FFFFFF",
            padding: "12px",
            borderRadius: 2,
            textAlign: "center",
            justifyContent: "center",
            boxShadow: "0px 2px 12px -2px #00000029",
            border: "2px solid green",
          }}
        >
          <Grid item xs={12} md={2.4}>
            <Typography
              sx={{
                fontStyle: "Regular",
                fontWeight: 400,
                fontSize: "16px",
                color: "#000000",
              }}
            >
              Customer Name
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "18px", fontStyle: "Bold" }}
            >
              {vehicleDetails?.customer?.name ?? "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={2.4}>
            <Typography
              sx={{
                fontStyle: "Regular",
                fontWeight: 400,
                fontSize: "16px",
                color: "#000000",
              }}
            >
              Customer ID
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "18px", fontStyle: "Bold" }}
            >
              {vehicleDetails?.customer?.id ?? "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={2.4}>
            <Typography
              sx={{
                fontStyle: "Regular",
                fontWeight: 400,
                fontSize: "16px",
                color: "#000000",
              }}
            >
              Auctioneer
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "18px", fontStyle: "Bold" }}
            >
              {vehicleDetails?.auctioneer ?? "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={2.4}>
            <Typography
              sx={{
                fontStyle: "Regular",
                fontWeight: 400,
                fontSize: "16px",
                color: "#000000",
              }}
            >
              Master ID
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "18px", fontStyle: "Bold" }}
            >
              {vehicleDetails?.buyer?.master_id ?? "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={2.4}>
            <Typography
              sx={{
                fontStyle: "Regular",
                fontWeight: 400,
                fontSize: "16px",
                color: "#000000",
              }}
            >
              Buyer ID
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700, fontSize: "18px", fontStyle: "Bold" }}
            >
              {vehicleDetails?.buyer?.name ?? "-"}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ mt: 4, mb: 4 }}>
        <Box sx={{ mb: 3, mt: 3 }}>
          <Grid container spacing={2}>
            {/* LEFT: slider (8 cols) */}
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 3,
                  overflow: "hidden",
                  height: 380,
                }}
              >
                 <HoverZoomSplit
                    src={encodeURI(
                        images[currentIndex]
                    )}
                    zoomSrc={encodeURI(
                      images[currentIndex]
                    )}
                    zoomScale={3}
                  />{" "}
                <CardMedia
                  component="img"
                  image={currentImage}
                  alt=""
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />

                {/* Left arrow */}
                <IconButton
                  onClick={handlePrev}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: 12,
                    transform: "translateY(-50%)",
                    bgcolor: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
                  }}
                  disabled={currentIndex === 0}
                >
                  <ArrowBackIcon />
                </IconButton>

                {/* Right arrow */}
                <IconButton
                  onClick={handleNext}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    right: 12,
                    transform: "translateY(-50%)",
                    bgcolor: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.8)" },
                  }}
                  disabled={currentIndex === total - 1}
                >
                  <ArrowForwardIcon />
                </IconButton>

                {/* Bottom-left: expand + download */}
                <Box
                  sx={{
                    position: "absolute",
                    left: 16,
                    bottom: 16,
                    display: "flex",
                    gap: 1.5,
                  }}
                >
                  <IconButton
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 2,
                      //  boxShadow: '0px 2px 12px -2px #00000029',
                      //  border: '2px solid green',
                      // boxShadow: 3,
                      width: 40,
                      height: 40,
                      "&:hover": { bgcolor: "#f5f5f5" },
                    }}
                    onClick={handleExpand}
                  >
                    <OpenInFullIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    sx={{
                      bgcolor: "#fff",
                      borderRadius: 2,
                      //  boxShadow: '0px 2px 12px -2px #00000029',
                      //  border: '2px solid green',
                      // boxShadow: 3,
                      width: 40,
                      height: 40,
                      "&:hover": { bgcolor: "#f5f5f5" },
                    }}
                    onClick={downloadAllImages}

                    // component="a"
                    // on
                    // href={currentImage}
                    // download
                  >
                    <FileDownloadOutlinedIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Bottom-right: 1/14 counter */}
                <Box
                  sx={{
                    position: "absolute",
                    right: 16,
                    bottom: 16,
                    bgcolor: "#fff",
                    borderRadius: 999,
                    // boxShadow: 3,
                    //  boxShadow: '0px 2px 12px -2px #00000029',
                    //  border: '2px solid green',
                    px: 1.75,
                    py: 0.75,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                  }}
                >
                  <ImageIcon fontSize="small" />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, lineHeight: 1 }}
                  >
                    {currentIndex + 1}/{total}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  maxHeight: 380,
                  overflowY: "auto",
                  pr: 1,
                  "&::-webkit-scrollbar": {
                    width: "8px", // Adjust for vertical scrollbar
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "lightgray", // Light gray color for the thumb
                    borderRadius: "10px", // Rounded thumb corners
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1", // Track color
                    borderRadius: "10px", // Rounded track corners
                  },
                  /* Firefox scrollbar color */
                  scrollbarColor: "lightgray #f1f1f1",
                }}
              >
                <Grid container spacing={1}>
                  {images.map((src, idx) => (
                    <Grid item xs={6} key={idx}>
                      <Box
                        onClick={() => handleThumbnailClick(idx)}
                        sx={{
                          cursor: "pointer",
                          borderRadius: 2,
                          overflow: "hidden",
                          border:
                            idx === currentIndex
                              ? "2px solid #1976d2"
                              : "2px solid transparent",
                        }}
                      >
                        <CardMedia
                          component="img"
                          image={src}
                          alt=""
                          sx={{
                            width: "100%",
                            height: 90,
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box sx={{ ml: 2 }}>
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} md={2} sm={4}>
            <Button
              sx={{
                backgroundColor:
                  activeTab === "vehicle-specs" ? "#5BBC0F" : "transparent",
                color: activeTab === "vehicle-specs" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor:
                    activeTab === "vehicle-specs" ? "#5BBC0F" : "#f5f5f5",
                },
                border:
                  activeTab === "vehicle-specs"
                    ? "1px solid #5BBC0F"
                    : "1px solid #ffff",
                width: "174px",
                height: "50px",
                paddingX: "18px",
                paddingY: "16px",
                boxShadow: 2,
                borderRadius: "10px",
              }}
              onClick={() => scrollToSection("vehicle-specs")}
            >
              Details & Specs
            </Button>
          </Grid>

          <Grid item xs={12} md={2} sm={4}>
            <Button
              sx={{
                backgroundColor:
                  activeTab === "title-keys" ? "#5BBC0F" : "transparent",
                color: activeTab === "title-keys" ? "#fff" : "#000",
                border:
                  activeTab === "title-keys"
                    ? "1px solid #5BBC0F"
                    : "1px solid #EDEDED",
                "&:hover": {
                  backgroundColor:
                    activeTab === "title-keys" ? "#5BBC0F" : "#f5f5f5",
                },
                width: "174px",
                height: "50px",
                paddingX: "18px",
                paddingY: "16px",
                stroke: 0.5,
                borderRadius: "10px",
              }}
              onClick={() => scrollToSection("title-keys")}
            >
              Title & Keys
            </Button>
          </Grid>

          <Grid item xs={12} md={2} sm={4}>
            <Button
              sx={{
                backgroundColor:
                  activeTab === "additional-info" ? "#5BBC0F" : "transparent",
                color: activeTab === "additional-info" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor:
                    activeTab === "additional-info" ? "#5BBC0F" : "#f5f5f5",
                },
                border:
                  activeTab === "additional-info"
                    ? "1px solid #5BBC0F"
                    : "1px solid #EDEDED",
                width: "174px",
                height: "50px",
                paddingX: "18px",
                paddingY: "16px",
                stroke: 0.5,
                borderRadius: "10px",
              }}
              onClick={() => scrollToSection("additional-info")}
            >
              Additional Info
            </Button>
          </Grid>
          <Grid item xs={12} md={2} sm={4}>
            <Button
              sx={{
                backgroundColor:
                  activeTab === "attachments" ? "#5BBC0F" : "transparent",
                color: activeTab === "attachments" ? "#fff" : "#000",
                border:
                  activeTab === "attachments"
                    ? "1px solid #5BBC0F"
                    : "1px solid #EDEDED",
                "&:hover": {
                  backgroundColor:
                    activeTab === "attachments" ? "#5BBC0F" : "#f5f5f5",
                },
                width: "174px",
                height: "50px",
                paddingX: "18px",
                paddingY: "16px",
                stroke: 0.5,
                borderRadius: "10px",
              }}
              onClick={() => scrollToSection("attachments")}
            >
              Attachments
            </Button>
          </Grid>

          <Grid item xs={12} md={2} sm={4}>
            <Button
              sx={{
                backgroundColor:
                  activeTab === "sales-info" ? "#5BBC0F" : "transparent",
                color: activeTab === "sales-info" ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor:
                    activeTab === "sales-info" ? "#5BBC0F" : "#f5f5f5",
                },
                border:
                  activeTab === "sales-info"
                    ? "1px solid #5BBC0F"
                    : "1px solid #EDEDED",
                width: "174px",
                height: "50px",
                paddingX: "18px",
                paddingY: "16px",
                stroke: 0.5,
                borderRadius: "10px",
              }}
              onClick={() => scrollToSection("sales-info")}
            >
              Sales Info
            </Button>
          </Grid>
          <Grid item xs={12} md={2} sm={4}>
            <Tooltip
              title={isContainerBooked ? "" : "Container not booked for this VIN"}
              disableHoverListener={isContainerBooked}
              disableFocusListener={isContainerBooked}
              disableTouchListener={isContainerBooked}
              arrow
              placement="top"
            >
              <Button
                sx={{
                  backgroundColor:
                    activeTab === "container-info" ? "#5BBC0F" : "transparent",
                  color: activeTab === "container-info" ? "#fff" : "#000",
                  "&:hover": {
                    backgroundColor:
                      activeTab === "container-info" ? "#5BBC0F" : "#f5f5f5",
                  },
                  border:
                    activeTab === "container-info"
                      ? "1px solid #5BBC0F"
                      : "1px solid #EDEDED",
                  width: "174px",
                  height: "50px",
                  paddingX: "18px",
                  paddingY: "16px",
                  stroke: 0.5,
                  borderRadius: "10px",
                }}
                onClick={() => {
                  if (!isContainerBooked) return;
                  scrollToSection("container-info");
                }}
              >
                Container info
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Vehicle Details & Specifications
        </Typography>
        <Box id="vehicle-specs" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Purchase Date:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {moment(vehicleDetails?.purchase_date).format(
                      "DD-MM-YYYY"
                    ) ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    VIN:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.vin ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    LOT:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.lot_number ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Currency:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.currency ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Booking Rate:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.invoice?.booking_rate ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Vehicle Value:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.value ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Other Charges:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.other_charges ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Model:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.veh_model?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Make:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.veh_make?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Color:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.color ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Vehicle Type:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.vehicle_type ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Country:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.country?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Location:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.location?.city_name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Off Site:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.off_site ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2} ml={0.3} mt={0.8}>
              <Grid
                item
                xs={12}
                sm={2}
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                Auction Notes
              </Grid>
              <Grid item xs={12} sm={10}>
                <Typography variant="body1">
                  {vehicleDetails?.notes ?? "-"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Title & Keys
        </Typography>
        <Box id="title-keys" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Title Name:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.title_status ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Title Receive Date:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.title_receive_date
                      ? moment(vehicleDetails?.title_receive_date).format(
                          "DD-MM-YYYY"
                        )
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Auction Pickup Date:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.pickup_date
                      ? moment(vehicleDetails?.pickup_date).format("DD-MM-YYYY")
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    GP Pin:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.gp_pin ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Title Status:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.title_status_key === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Title Issue:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.is_title_issue === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Vehicle Key:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.vehicle_key === true ? "Yes" : vehicleDetails?.vehicle_key === false ? "No" : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Key Lost:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.key_lost === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Vehicle Cancelled:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.vehicle_cancelled === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Vehicle Relist:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.is_relist === true ? "Yes" : "No"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Relist Reason:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.relist_reason ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={0.8} ml={0.3}>
              <Grid
                item
                xs={12}
                sm={2}
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                Title Issue Description:
              </Grid>
              <Grid item xs={12} sm={10}>
                <Typography variant="body1">
                  {vehicleDetails?.title_issue_desc ?? "-"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Additional Information
        </Typography>
        <Box id="additional-info" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                {vehicleDetails?.body_style && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Body Style:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="boCreateVehicledy1">
                        {"-"}
                      </Typography>
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Odometer:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.odometer_reading?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Cylinders:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.cylinders_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Drive Train:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.drive_train_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Fuel:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.fuel_type_details?.name ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Engine Type:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.engine_type_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Transmission:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.transmission_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Highlights:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.highlights_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Primary Damage:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.primary_damage_details?.name ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Sales Information
        </Typography>
        <Box id="sales-info" sx={{ mb: 3, mt: 3, ml: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Sale Date:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.sale_date
                      ? moment(vehicleDetails?.sale_date).format("DD-MM-YYYY")
                      : "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Sale Agent:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.sale_agent_details?.name ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Remarks:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  {vehicleDetails?.remarks ?? "-"}
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Sold Price $:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {vehicleDetails?.sold_price ?? "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", color: "#555" }}
                  >
                    Sold Price (AED):
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <Typography variant="body1">
                    {CommaSeparator(
                      parseFloat(vehicleDetails?.sold_price * 3.675).toFixed(2)
                    ) ?? "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

      {vehicleDetails?.vehicle && (
        <>
          <Box sx={{ m: 4 }}>
            <Typography
              sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
            >
              Container Information
            </Typography>
            <Box id="container-info" sx={{ mb: 3, mt: 3, ml: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Container no:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.container_no ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Container Size:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.container?.name ??
                          "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Booking no:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.booking_no ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Shipping Line:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.ship_line?.name ??
                          "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Loading Port:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.loading_port
                          ?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Destination:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.dest?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Notes:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.notes ?? "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Loading Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {moment(vehicleDetails?.vehicle?.loading_date).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Export Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {moment(vehicleDetails?.vehicle?.export_date).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        ETA Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {moment(vehicleDetails?.vehicle?.eta).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Arriver At Port Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {moment(
                          vehicleDetails?.vehicle?.arrived_port_date
                        ).format("DD-MM-YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Arriver At G.Yard Date:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {moment(
                          vehicleDetails?.vehicle?.arrived_galaxy_date
                        ).format("DD-MM-YYYY")}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Galaxy Yard:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.g_yard?.name ?? "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />

          <Box sx={{ m: 2 }}>
            <Box sx={{ mb: 3, mt: 3, ml: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Shipping Vendor:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.ship_vendor?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Towing Vendor:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.tower?.name ?? "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Clearance Vendor:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">
                        {vehicleDetails?.vehicle?.shipping?.clearer?.name ??
                          "-"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Declration No:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">{"-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Container DT Status:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">{"-"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold", color: "#555" }}
                      >
                        Last Updated:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Typography variant="body1">{"-"}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>

          <Divider sx={{ my: 3, ml: 1.5, mr: 1.5 }} />
        </>
      )}

      <Box sx={{ m: 4 }}>
        <Typography
          sx={{ fontSize: "26px", fontWeight: 700, fontStyle: "bold" }}
        >
          Attachments
        </Typography>

        <Box id="attachments" sx={{ mt: 3 }}>
          {/* outer container with border + radius */}
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              overflow: "hidden",
            }}
          >
            {attachments.map((file, index) => (
              <Box
                key={file.id || index}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f5f5f5",
                  px: 2.5,
                  py: 1.5,
                }}
              >
                <Grid container alignItems="center">
                  <Grid item xs={12} sm={8}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box
                        component="img"
                        src={pdfIcon}
                        alt="pdf"
                        sx={{ width: 26, height: 26, mr: 1.5 }}
                      />

                      <Typography
                        variant="body1"
                        sx={{ color: "#333", fontSize: "14px" }}
                      >
                        {file.doc_id === 1
                          ? "At the time of purchase"
                          : "At the time of delivery"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: { xs: "flex-start", sm: "flex-end" },
                        mt: { xs: 1, sm: 0 },
                      }}
                    >
                      <div
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleAttachmentDownload(file?.invoice_attachment)
                        }
                      >
                        <FiDownload size={26} />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default VehicleBookingDetail;
